import {Directive, ElementRef, EmbeddedViewRef, Input, OnChanges, OnDestroy, SimpleChanges, TemplateRef} from '@angular/core';
import tippy, {Instance} from 'tippy.js';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- intentionally unprefixed: mirrors the tippy.js API this directive wraps
  selector: '[tippy]'
})
export class TippyDirective implements OnChanges, OnDestroy {
  @Input('tippy') popup: TemplateRef<any>;
  // tippy.js api docs gonna be your best friend
  @Input() tippyOptions = {};
  @Input() templateContext?: {[name: string]: any} = {};

  private view: EmbeddedViewRef<any>;
  private instance: Instance;

  constructor(private el: ElementRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Only a different template warrants a new view and instance. Everything else updates what is
    // already there: rebuilding on every change left the previous instance and view alive, so each
    // change to a bound value leaked a tippy instance and its popper element.
    if (!this.instance || changes.popup) {
      this.build();
      return;
    }
    if (changes.templateContext) {
      Object.assign(this.view.context, this.templateContext);
      this.view.detectChanges();
    }
    if (changes.tippyOptions) {
      this.instance.setProps(this.tippyOptions);
    }
  }

  ngOnDestroy(): void {
    this.teardown();
  }

  private build(): void {
    this.teardown();
    this.view = this.popup.createEmbeddedView(this.templateContext);
    this.view.detectChanges();
    this.instance = tippy(this.el.nativeElement as Element, {...this.tippyOptions, content: this.view.rootNodes[0]});
  }

  private teardown(): void {
    this.instance?.destroy();
    this.view?.destroy();
    this.instance = null;
    this.view = null;
  }
}
